<template>
  <div>
    <b-modal
      id="modal-info-temp"
      ref="modal-info-temp"
      size="sm"
      :modal-class="
        $store.state.sidebar.sideBarOpen
          ? 'mc-modal-info mc-modal-options--temp'
          : `mc-modal-info mc-modal-options--temp mc-panel-close ${
              swipped ? 'mc-modal-info--swipe' : null
            }`
      "
      hide-header
      hide-footer
      scrollable
      no-close-on-backdrop
      hide-backdrop
      centered
      no-enforce-focus
      @hidden="onCloseModal"
      @show="onShow"
    >
      <span class="mc-modal-info__swipe" @click="onSwipe"></span>
      <h4 class="mc-modal-info__head" v-if="$store.state.map.infoWindow.type === 'fleet'">
        {{ $t('global.object.detailFleet') }}
        <i class="mc-fa icon-outline_close" @click="close"></i>
      </h4>

      <ul class="mc-modal-info__list">
        <li>
          <dl class="mc-modal-info__list-detail">
            <dt>{{ $t('global.fleet') }}</dt>
            <dd>
              {{
                $store.state.map.infoWindow.detail.licensePlate
                  ? $store.state.map.infoWindow.detail.licensePlate
                  : $store.state.map.infoWindow.detail.vehicle.licensePlate
              }}
              /
              {{
                $store.state.map.infoWindow.detail.vehicle.vehicleType
                  ? $store.state.map.infoWindow.detail.vehicle.vehicleType.type
                  : '-'
              }}
              /
              {{
                $store.state.map.infoWindow.detail.vehicle.vehicleType
                  ? $store.state.map.infoWindow.detail.vehicle.vehicleType.category
                  : '-'
              }}
            </dd>
            <dt v-if="$store.state.map.pickedColumns.includes('driverName')">
              {{ $t('global.object.driverName') }}
            </dt>
            <dd v-if="$store.state.map.pickedColumns.includes('driverName')">
              {{
                $store.state.map.infoWindow.detail.vehicle.driver1 != null
                  ? $store.state.map.infoWindow.detail.vehicle.driver1.fullname
                  : 'Tidak Ada Pengemudi'
              }}
            </dd>
          </dl>
        </li>
        <li>
          <b-badge
            class="bg-success"
            :title="$t('liveView.filter.moving')"
            v-if="$store.state.map.infoWindow.detail.calculatedMotionStatus === 'M'"
            >{{ $t('liveView.filter.moving') }}</b-badge
          >
          <b-badge
            class="bg-warning"
            :title="$t('liveView.filter.idle')"
            v-else-if="$store.state.map.infoWindow.detail.calculatedMotionStatus === 'I'"
            >{{ $t('liveView.filter.idle') }}</b-badge
          >
          <b-badge
            class="bg-danger"
            :title="$t('liveView.filter.parking')"
            v-else-if="$store.state.map.infoWindow.detail.calculatedMotionStatus === 'P'"
            >{{ $t('liveView.filter.parking') }}</b-badge
          >
          <b-badge
            class="bg-secondary"
            :title="$t('liveView.filter.offline')"
            v-else-if="$store.state.map.infoWindow.detail.calculatedMotionStatus === 'O'"
            >{{ $t('liveView.filter.offline') }}</b-badge
          >
          <b-badge
            class="bg-secondary"
            :title="$t('liveView.filter.offline')"
            v-else-if="$store.state.map.infoWindow.detail.calculatedMotionStatus === 'U'"
            >{{ $t('liveView.filter.offline') }}</b-badge
          >
          <dl class="mc-modal-info__list-detail">
            <dt v-if="$store.state.map.pickedColumns.includes('lastSeen')">
              {{ $t('global.text.lastSeen') }}
            </dt>
            <dd v-if="$store.state.map.pickedColumns.includes('lastSeen')">
              {{ momentDMYH($store.state.map.infoWindow.detail.lastPositionStatus) }}
              WIB
            </dd>
            <dt>{{ $t('global.object.lastLocation') }}</dt>
            <dd v-if="$store.state.map.infoWindow.address == ''">
              <b-skeleton width="70%" />
            </dd>
            <dd v-else>{{ $store.state.map.infoWindow.address ?? '-' }}</dd>
          </dl>

          <b-row
            class="mc-modal-info__list-detail-row"
            v-if="$store.state.map.infoWindow.type === 'fleet'"
          >
            <b-col md="6" v-if="$store.state.map.infoWindow.detail.calculatedMotionStatus !== 'M'">
              <dl class="mc-modal-info__list-detail">
                <dt>{{ $t('global.field.stopDuration') }}</dt>
                <dd>
                  {{ $store.state.map.infoWindow.detail.timeInStatus }}
                  {{ $t('global.time.minutes') }}
                </dd>
              </dl>
            </b-col>
            <b-col
              md="6"
              v-else-if="
                $store.state.map.infoWindow.detail.calculatedMotionStatus === 'M' &&
                $store.state.map.pickedColumns.includes('speed')
              "
            >
              <dl class="mc-modal-info__list-detail">
                <dt>{{ $t('global.object.speed') }}</dt>
                <dd>
                  {{ $store.state.map.infoWindow.detail.calculatedSpeed }}
                  Km/{{ $t('global.time.hours') }}
                </dd>
              </dl>
            </b-col>
            <b-col md="6" v-if="$store.state.map.pickedColumns.includes('engineStatus')">
              <dl class="mc-modal-info__list-detail">
                <dt>{{ $t('global.object.machineStatus') }}</dt>
                <dd>
                  {{ $store.state.map.infoWindow.detail.engineOn ? 'Hidup' : 'Mati' }}
                </dd>
              </dl>
            </b-col>
            <b-col md="6">
              <dl class="mc-modal-info__list-detail">
                <dt>{{ $t('global.object.mileage') }}</dt>
                <dd>{{ $store.state.map.infoWindow.detail.sumDistance }} Km</dd>
              </dl>
            </b-col>
            <b-col md="6">
              <dl class="mc-modal-info__list-detail">
                <dt>{{ $t('global.object.tripTime') }}</dt>
                <dd>
                  {{ $store.state.map.infoWindow.detail.sumDrivetimeFormatted }}
                </dd>
              </dl>
            </b-col>
            <b-col md="6">
              <dl class="mc-modal-info__list-detail">
                <dt>{{ $t('global.object.fuel') }}</dt>
                <dd>
                  {{
                    $store.state.map.infoWindow.detail.fuelFiltered
                      ? ($store.state.map.infoWindow.detail.fuelFiltered / 100) *
                        $store.state.map.infoWindow.detail.fuelCapacity
                      : '-'
                  }}
                </dd>
              </dl>
            </b-col>
            <b-col md="6" v-if="$store.state.map.pickedColumns.includes('temperature')">
              <dl class="mc-modal-info__list-detail">
                <dt>{{ $t('global.alert.temperature') }}</dt>
                <dd v-if="$store.state.map.infoWindow.detail.temperature">
                  <span
                    class="mc-modal__temp"
                    v-for="(row, index) in $store.state.map.infoWindow.detail.temperature"
                    :key="index"
                  >
                    {{ row ? `${row} &#186; C ` : '-' }}
                  </span>
                </dd>
                <dd v-else>-</dd>
              </dl>
            </b-col>
          </b-row>
        </li>
        <li v-if="isContractTemporaryLiveView">
          <dl class="mc-modal-info__list-detail">
            <dt>{{ $t('trackingTemp.liveTrack.contractName') }}</dt>
            <dd>{{ contractName }}</dd>
            <dt>{{ $t('trackingTemp.liveTrack.validityPeriod') }}</dt>
            <dd>{{ contractValidityPeriod }}</dd>
            <dt>{{ $t('trackingTemp.liveTrack.remainingContractTime') }}</dt>
            <dd>{{ contractRemainingTime }}</dd>
            <dt>{{ $t('trackingTemp.liveTrack.totalGpsMileage') }}</dt>
            <dd>{{ contractTotalMileage }}</dd>
            <dt>{{ $t('trackingTemp.liveTrack.maxMileagePerMonth') }}</dt>
            <dd>{{ contractMaxMileage }}</dd>
            <dt>{{ $t('trackingTemp.liveTrack.vehicleUsage') }}</dt>
            <dd>{{ contractVehicleUsage }}</dd>
          </dl>
        </li>
      </ul>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { Helper } from '@/mixin/helper'
import responsive from '@/mixin/responsive'

export default {
  name: 'ModalInfo',
  mixins: [Helper, responsive],
  props: {
    temporaryLiveView: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      swipped: false,
      phaseOneShow: false,
      popOverConfiguration: false,
      popOverShare: false,
      modalStatus: {
        configuration: {
          status: false,
          title: '',
          type: '',
        },
      },
    }
  },

  computed: {
    customerContract() {
      return this.temporaryLiveView?.customerContract || null
    },

    isContractTemporaryLiveView() {
      return Boolean(this.customerContract?.uuid)
    },

    selectedContractVehicle() {
      if (!this.isContractTemporaryLiveView) return null

      const selectedVehicleId = this.$store.state.map.infoWindow.detail?.vehicleId

      if (selectedVehicleId == null) return null

      return (
        this.customerContract?.vehicles?.find(
          (vehicle) => String(vehicle?.vehicleId) === String(selectedVehicleId)
        ) || null
      )
    },

    contractName() {
      const parts = [this.customerContract?.number, this.customerContract?.customer?.name].filter(
        Boolean
      )
      return parts.length ? parts.join(' - ') : '-'
    },

    contractValidityPeriod() {
      const createdOn = this.temporaryLiveView?.createdOn
      const expiresOn = this.temporaryLiveView?.expiresOn

      if (!createdOn || !expiresOn) return '-'

      return `${this.momentDateShortMonth(createdOn)} - ${this.momentDateShortMonth(expiresOn)}`
    },

    contractRemainingTime() {
      return this.formatRemainingContractTime(this.temporaryLiveView?.expiresOn)
    },

    contractTotalMileage() {
      if (!this.selectedContractVehicle || this.selectedContractVehicle?.totalMileage == null)
        return '-'

      return this.formatContractMileage(this.selectedContractVehicle.totalMileage)
    },

    contractMaxMileage() {
      if (this.customerContract?.maxMileage == null) return '-'

      return this.formatContractMileage(this.customerContract.maxMileage)
    },

    contractVehicleUsage() {
      const totalMileage = Number(this.selectedContractVehicle?.totalMileage)
      const maxMileage = Number(this.customerContract?.maxMileage)

      if (
        !this.selectedContractVehicle ||
        this.selectedContractVehicle?.totalMileage == null ||
        this.customerContract?.maxMileage == null ||
        Number.isNaN(totalMileage) ||
        Number.isNaN(maxMileage) ||
        maxMileage === 0
      ) {
        return '-'
      }

      return `${Math.round((totalMileage / maxMileage) * 100)}%`
    },
  },

  methods: {
    onShow() {
      this.swipped = false
    },

    onSwipe() {
      this.swipped = !this.swipped
    },

    onCloseModal() {
      if (this.$store.state.map.infoWindow.type === 'fleet')
        this.$store.commit('map/TYPE_OF_MAP_INFOWINDOW', 'fleet')
      this.swipped = false
    },

    formatContractMileage(value) {
      const numericValue = Number(value)

      if (Number.isNaN(numericValue)) return '-'

      return `${new Intl.NumberFormat('id-ID', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 1,
      }).format(numericValue)} km`
    },

    formatRemainingContractTime(expiresOn) {
      const now = moment().startOf('day')
      const expiresAt = moment(expiresOn).startOf('day')

      if (!expiresOn || !expiresAt.isValid() || expiresAt.isSameOrBefore(now)) return '-'

      const cursor = now.clone()
      const years = expiresAt.diff(cursor, 'years')
      cursor.add(years, 'years')

      const months = expiresAt.diff(cursor, 'months')
      cursor.add(months, 'months')

      const remainingDays = Math.max(expiresAt.diff(cursor, 'days'), 0)
      const duration = []

      if (years > 0) {
        duration.push(this.formatRemainingTimeUnit(years, 'year'))
      }

      if (months > 0) {
        duration.push(this.formatRemainingTimeUnit(months, 'month'))
      }

      if (remainingDays > 0 || duration.length === 0) {
        duration.push(this.formatRemainingTimeUnit(remainingDays || 1, 'day'))
      }

      return duration.join(' ')
    },

    formatRemainingTimeUnit(value, unit) {
      const translations = {
        id: {
          year: 'tahun',
          years: 'tahun',
          month: 'bulan',
          months: 'bulan',
          day: 'hari',
          days: 'hari',
        },
        en: {
          year: 'year',
          years: 'years',
          month: 'month',
          months: 'months',
          day: 'day',
          days: 'days',
        },
      }

      const locale = this.$i18n.locale === 'en' ? 'en' : 'id'
      const key = value === 1 ? unit : `${unit}s`

      return `${value} ${translations[locale][key]}`
    },

    close() {
      this.$bvModal.hide('modal-info-temp')
      if (this.mediaQuery.matches) {
        this.$store.commit('sidebar/toggleSideBar')
      }
    },

    share(param) {
      if (param === 'wa') {
        window.open(
          'https://wa.me/?text=_Location from vehicle *' +
            this.$store.state.map.infoWindow.detail.licensePlate +
            '* http%3A%2F%2Fmaps.google.com%2Fmaps%3F%26z%3D15%26mrt%3Dyp%26t%3Dm%26q%3D' +
            this.$store.state.map.infoWindow.position.lat +
            '%2B' +
            this.$store.state.map.infoWindow.position.lng,
          '_blank'
        )
      } else if (param === 'copy') {
        let url = `http://maps.google.com/maps?&z=15&mrt=yp&t=m&q=${this.$store.state.map.infoWindow.position.lat}+${this.$store.state.map.infoWindow.position.lng}`
        this.$store.state.map.infoWindow.position.lng
        navigator.clipboard.writeText(url)

        this.$mcToast.info(this.$t('global.alert.text.linkCopied'), {
          position: 'top-center',
          timeout: 3000,
          closeOnClick: true,
          pauseOnFocusLoss: false,
          pauseOnHover: false,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: 'button',
          icon: false,
          rtl: false,
        })
      }

      this.popOverShare = !this.popOverShare
    },

    turnOnEngine() {
      var self = this
      this.$dialog
        .confirm(`${this.$store.state.map.infoWindow.detail.licence_plat}, Akan dihidupkan?`)
        .then(function (dialog) {
          setTimeout(() => {
            self.$mcToast.success(
              self.$t('global.alert.text.engineTurnOnSuccess', { plate: self.$store.state.map.infoWindow.detail.licence_plat })
            )
            dialog.loading(false)
            dialog.close()
          }, 500)
        })
        .catch(function () {
          self.$mcToast.warning(
            self.$t('global.alert.text.engineTurnOnFailed', { plate: self.$store.state.map.infoWindow.detail.licence_plat })
          )
        })
    },

    turnOffEngine() {
      var self = this
      this.$dialog
        .confirm(`${this.$store.state.map.infoWindow.detail.licence_plat}, Akan dimatikan?`)
        .then(function (dialog) {
          setTimeout(() => {
            self.$mcToast.success(
              self.$t('global.alert.text.engineTurnOffSuccess', { plate: self.$store.state.map.infoWindow.detail.licence_plat })
            )
            dialog.loading(false)
            dialog.close()
          }, 500)
        })
        .catch(function () {
          self.$mcToast.warning(
            self.$t('global.alert.text.engineTurnOffFailed', { plate: self.$store.state.map.infoWindow.detail.licence_plat })
          )
        })
    },

    CloseInfo() {
      this.$store.dispatch('map/closeInfo', false)
    },

    setModal(row) {
      this.$store.dispatch('fleets/setHistory', {
        hullNo: row.vehicle.hullNo,
        type: row.vehicle.vehicleType.type,
        category: row.vehicle.vehicleType.category,
        licensePlate: row.licensePlate,
        imei: row.vehicle.imei,
        vehicleId: row.vehicleId,
        driver: row.driver,
        direction: row.direction,
        calculatedMotionStatus: row.calculatedMotionStatus,
        tripDrivetime: row.tripDrivetime,
        tripDistance: row.tripDistance,
        tripstartOn: row.tripstartOn,
        lastPacket: row.lastPacket,
        latitude: row.latitude,
        longitude: row.longitude,
        lastPositionStatus: row.lastPositionStatus,
      })
      this.$store.dispatch('map/modalFleetHistory', true)

      if (this.mediaQuery.matches) {
        this.$store.commit('sidebar/toggleSideBar')
      }
    },

    showModalConfiguration(title, type) {
      this.modalStatus.configuration.status = true
      this.modalStatus.configuration.title = title
      this.modalStatus.configuration.type = type

      setTimeout(() => {
        this.popOverConfiguration = !this.popOverConfiguration
      }, 10)
    },

    closeModalConfiguration() {
      this.modalStatus.configuration.status = false
      this.modalStatus.configuration.title = ''
      this.modalStatus.configuration.type = ''
    },
  },
}
</script>
